// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"f970e96b","1930":"d7a6829a","7650":"8a1b5f5f","8688":"6a7ad95e"}[chunkId] + ".chunk.css";
};